export default {
  id: "page4",
  header: "Informacje na temat zwyczajów kulinarnych i używanych produktów",

  questions: [
    {
      type: "justlabel",
      number: "18",
      label:
        "W poniższej tabeli proszę zaznaczyć, jak często przygotowuje Pan(i) następujące rodzaje ciast, deserów bądź dań?",
      info:
        "Dla każdego rodzaju ciast, deserów, dań proszę zaznaczyć jedną odpowiedź pod odpowiednią częstotliwością."
    },
    {
      type: "choice_names",
      options: [
        "Raz w tygodniu lub częściej",
        "Raz na dwa tygodnie",
        "Raz w miesiącu",
        "Raz na 2-3 miesiące",
        "Rzadziej ",
        "Wcale"
      ],
      topLine: true,
      bottomLine: true
    },
    {
      label:
        "[A] Desery na kilka porcji typu kisiel do gotowania, budyń do gotowania na mleku, galaretka",
      type: "radio",
      id: "ankieta_deseryPorcjeCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[B] Ciasta z samodzielnie dobranych składników (przy użyciu dodatków typu proszek do pieczenia, aromaty, cukry, drożdże)",
      type: "radio",
      id: "ankieta_ciastaSelfCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[C] Ciasta z torebki lub kartonika (babki, babeczki, serniki, ciasta z kremami)",
      type: "radio",
      id: "ankieta_ciastaMixCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[D] Pikantne / słone wypieki typu tarty, bułeczki, muffinki, mogą być również na bazie gotowego ciasta np. francuskiego",
      type: "radio",
      id: "ankieta_sloneWypiekiCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[E] Słodkie dania obiadowe lub kolacyjne typu ryż, makaron, kluski na słodko – przygotowane samodzielnie",
      type: "radio",
      id: "ankieta_slodkieDaniaCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[F] Dania obiadowe przy użyciu dodatków typy Fix do…/ Pomysł na …",
      type: "radio",
      id: "ankieta_daniaFixCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label: "[G] Zupy, sosy z torebki",
      type: "radio",
      id: "ankieta_zupyTorebkiCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[H] Słodkie dania typu naleśniki, racuchy, pankejki/ pancakes, gofry",
      type: "radio",
      id: "ankieta_nalesnikiGofryCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label:
        "[I] Małe wypieki typu słodkie bułeczki/ drożdżówki, rogale, croissanty, donutsy itp.",
      type: "radio",
      id: "ankieta_maleWypiekiCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    },
    {
      label: "[J] Ciasta/ małe wypieki pieczone w Air Fryerze",
      type: "radio",
      id: "ankieta_airFryerCz",
      required: true,
      columns: true,
      labelStrong: false,
      options: [
        { value: "1" },
        { value: "2" },
        { value: "3" },
        { value: "4" },
        { value: "5" },
        { value: "6" }
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page4.js